import { memo } from 'react'
import Anchor from '../Anchor'
import PowerStatement from './PowerStatement'

type Props = {
  sectionId: string
  isStepByStepFlow?: boolean
  isFoldable?: boolean
}

const PowerStatementSection = (props: Props): JSX.Element => {
  const { sectionId, isStepByStepFlow, isFoldable = true } = props
  return (
    <Anchor id={sectionId} scrollOffsetTop={70}>
      <PowerStatement isFoldable={isFoldable} isStepByStepFlow={isStepByStepFlow} />
    </Anchor>
  )
}

export default memo(PowerStatementSection)
